/**
 * Created by JackCui on 2020/10/21
 */
import batchHandleUrl from '../../utils/url-handle'

const Api = {
  // 值对象-获取全部tabs
  getAllTab: {
    url: '/apaas/layout/getAllTab',
    type: 'post'
  },
  // 值对象-获取单个tab下的布局信息
  getTabLayout: {
    url: '/apaas/layout/getTabLayout',
    type: 'post'
  },
  // 值对象-列表
  objectListPage: {
    url: '/apaas/object/value/list',
    type: 'post'
  },
  // 列表-删除
  objectValueDelete: {
    url: '/apaas/object/value/delete',
    type: 'post'
  },
  // 列表-批量删除
  objectValueBatchDelete: {
    url: '/apaas/object/value/batch/delete',
    type: 'post'
  },
  // 获取按钮路由
  routeLayout: {
    url: '/apaas/route/routeLayout',
    type: 'post'
  },
  // 获取不控权按钮路由
  noAuthRouteLayout: {
    url: '/apaas/route/noAuthRouteLayout',
    type: 'post'
  },
  // 值列表导出
  excelExport: {
    url: '/apaas/object/excel/export',
    type: 'post'
  },
  getPageRule: {
    url: '/apaas/rule/getPageRule',
    type: 'POST'
  },
  // 按钮规则
  buttonRules: {
    url: '/apaas/rule/getButtonShowRuleList',
    type: 'post'
  },
  templateExport: {
    url: '/apaas/template/export',
    type: 'post'
  },
  // template
  queryTemplate: {
    url: '/apaas/excel/queryTemplate',
    type: 'post'
  },
  // 导出
  export: {
    url: '/apaas/excel/export',
    type: 'post'
  },
  // 导入
  import: {
    url: '/apaas/excel/import',
    type: 'post'
  }
}

export default batchHandleUrl(Api)
